import getAuthenticationUrlOperation from 'owa-service/lib/operation/getAuthenticationUrlOperation';
import type AuthenticationUrlResponseCode from 'owa-service/lib/contract/AuthenticationUrlResponseCode';
import getMailboxRequestOptions from 'owa-service/lib/getMailboxRequestOptions';
import type { MailboxInfo } from 'owa-client-types';

export async function getAuthenticationUrl(mailboxInfo?: MailboxInfo): Promise<string> {
    const defaultAuthUrl = 'https://login.microsoftonline.com/'; //Set Prod login Url as default
    /* eslint-disable-next-line owa-custom-rules/require-getMailboxRequestOptions  -- (https://aka.ms/OWALintWiki)
     * MailboxReqestOptions should be passed into service request calls, see https://aka.ms/multiaccountlinter
     *	> All service requests calls must pass in a MailboxRequestOptions. The can be obtained by passing a MailboxInfo to the getMailboxRequestOptions function. */
    const response = await getAuthenticationUrlOperation({}, getMailboxRequestOptions(mailboxInfo));
    let authUrl;

    if (response?.ResultCode === 0 && response?.AuthenticationUrl) {
        // Sample success response- {"ResultCode":0,"WebSessionType":0,"AuthenticationUrl":"https://login.microsoftonline.com/common/oauth2/authorize?client_id={clientId}&redirect_uri={redirectUri}&resource={resource}&response_mode=form_post&response_type=code+id_token&scope=openid&msafed=0&prompt=none&client-request-id={clientRequestId}&protectedtoken=true&claims={claims}&nonce={nonce}&state={state}","ImplicitGrantAuthorizationUrl":""}
        const arr = response.AuthenticationUrl.split('/');
        authUrl = arr[0] + '//' + arr[2] + '/';
    }

    return authUrl ? authUrl : defaultAuthUrl;
}
